import { render, staticRenderFns } from "./NearStoresLinkEl.vue?vue&type=template&id=505352a6&scoped=true&"
import script from "./NearStoresLinkEl.vue?vue&type=script&lang=ts&"
export * from "./NearStoresLinkEl.vue?vue&type=script&lang=ts&"
import style0 from "./NearStoresLinkEl.vue?vue&type=style&index=0&id=505352a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505352a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VOverlay,VProgressCircular,VSheet})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
